


// src/pages/Home.jsx
import React from 'react';
import MainLayout from '../components/Layouts/MainLayout';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import ContactUs from '../components/PagesComponents/ContactUs';

const ContactPage = () => (
  <MainLayout>
    <InnerBanner pageKey="contact" />
    <ContactUs/>
  </MainLayout>
);

export default ContactPage;
